import { Container } from '@mui/material'
import React from 'react'
import { UsersTable } from '../../components/data/user/UsersTable'

const Users = () => {
  return (
    <Container maxWidth='xl' sx={{ p: 2, maxWidth: '100vw' }}>
      <UsersTable />
    </Container>
  )
}

export default Users
